<template>
  <div class="boxbgcolor">
    <div class="left content-left">
      <ShareParkingTree
        v-on:handleTreeClick="handleTreeClick"
        shareType="share"
        moduleName="parking"
      ></ShareParkingTree>
    </div>
    <div class="right content-right list">
      <!-- 未选择停车场时的提示 -->
      <div v-if="!selectedParkingId" class="no-parking-tip">
        <el-empty description="请先选择左侧的停车场"></el-empty>
      </div>

      <!-- 选择停车场后显示的内容 -->
      <div v-else>
        <!--左侧上方搜索框-->
        <div class="searchbox chargeSearchbox">
          <form action="#" method="get" class="form-inline form-float">
            <!-- <div class="form-group">
              <label for>支付渠道:</label>
              <el-select
                v-model="search.payChannel"
                placeholder="请选择支付渠道"
                clearable
                @change="searchList"
              >
                <el-option
                  v-for="item in paymentChannels"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div> -->
            <div class="form-group">
              <label for>启用状态:</label>
              <el-select
                v-model="search.openFlag"
                placeholder="请选择状态"
                clearable
                @change="searchList"
              >
                <el-option label="启用" value="y"></el-option>
                <el-option label="停用" value="n"></el-option>
              </el-select>
            </div>
            <div class="form-group others">
              <span class="search_btn">
                <button
                  @click="searchList"
                  type="button"
                  class="btn btn-primary"
                  id="search_btn"
                >
                  查询
                </button>
              </span>
              <span class="add_btn" v-if="tableListData.length<=0">
                <el-tooltip 
                  :content="tableListData.length >= 1 ? '每个停车场仅允许添加一个支付配置' : ''"
                  placement="top"
                  :disabled="tableListData.length < 1"
                >
                  <button
                    type="button"
                    class="btn btn-default"
                    :class="{ 'btn-disabled': tableListData.length >= 1 }"
                    id="addarea"
                    @click="addOrEdit()"

                  >
                    添加
                  </button>
                </el-tooltip>
              </span>
            </div>
          </form>
        </div>
        <div class="list-right">
          <el-table
            ref="table"
            border
            :data="tableListData"
            height="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
          >
            <el-table-column
              show-overflow-tooltip
              label="支付渠道"
              prop="payChannel"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="商户代码"
              prop="merchantId"
            ></el-table-column>
            <!-- <el-table-column
              show-overflow-tooltip
              label="商户柜台代码"
              prop="posId"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="分行代码"
              prop="branchId"
            ></el-table-column> -->
            <el-table-column
              show-overflow-tooltip
              label="启用状态"
              prop="openFlag"
            >
              <template slot-scope="scope">
                <span
                  :class="
                    scope.row.openFlag === 'y'
                      ? 'status-enabled'
                      : 'status-disabled'
                  "
                >
                  {{ scope.row.openFlag === "y" ? "启用" : "停用" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="添加时间"
              prop="crtTime"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="最近更新时间"
              prop="updTime"
            ></el-table-column>

            <el-table-column show-overflow-tooltip label="操作" width="280px">
              <template slot-scope="scope">
                <button
                  type="button"
                  class="view"
                  @click="viewDetail(scope.row)"
                >
                  查看详情
                </button>

                <button
                  type="button"
                  class="edit"
                  @click="addOrEdit(scope.row.id)"
                >
                  编辑
                </button>

                <button
                  type="button"
                  class="reset"
                  @click="toggleStatus(scope.row, scope.row.openFlag)"
                  style="width: 79px"
                >
                  {{ scope.row.openFlag === "y" ? "停用" : "启用" }}
                </button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- <Page v-on:pagination="receivePaginationData"></Page> -->

    <!-- 添加/编辑-->
    <el-dialog
      title="添加/编辑支付配置"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormVisible"
      width="700px"
      @open="openDialog"
      @close="closeDialog"
    >
      <el-form
        ref="form"
        label-position="right"
        :model="formData"
        :rules="rules"
        :label-width="formLabelWidth"
        class="form-edit"
      >
        <el-form-item label="支付渠道" prop="payChannel">
          <el-col :span="20">
            <el-select
              v-model="formData.payChannel"
              placeholder="请选择支付渠道"
              style="width: 100%"
              disabled
            >
              <el-option
                v-for="item in paymentChannels"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="商户代码" prop="merchantId">
          <el-col :span="20">
            <el-input
              v-model.trim="formData.merchantId"
              placeholder="请输入商户代码"
              style="width: 100%"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商户柜台代码" prop="posId">
          <el-col :span="20">
            <el-input
              v-model.trim="formData.posId"
              placeholder="请输入商户柜台代码"
              style="width: 100%"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="分行代码" prop="branchId">
          <el-col :span="20">
            <el-input
              v-model.trim="formData.branchId"
              placeholder="请输入分行代码"
              style="width: 100%"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="公钥" prop="pub">
          <el-col :span="20">
            <el-input
              v-model="formData.pub"
              type="textarea"
              :rows="4"
              placeholder="请输入公钥"
              style="width: 100%"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="启用标志" prop="openFlag">
          <el-col :span="20">
            <el-radio-group v-model="formData.openFlag">
              <el-radio label="y">启用</el-radio>
              <el-radio label="n">停用</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addEditTrue">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 查看详情-->
    <el-dialog
      title="查看支付配置详情"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="detailDialogVisible"
      width="800px"
      custom-class="detail-dialog"
    >
      <div class="detail-header">
        <div class="detail-title">
          <i class="el-icon-bank-card"></i>
          <span>支付配置信息</span>
        </div>
      </div>
      
      <div class="detail-content">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-section">
              <h4 class="section-title">
                <i class="el-icon-info"></i>
                基本信息
              </h4>
              <div class="detail-item">
                <label class="detail-label">支付渠道：</label>
                <span class="detail-value channel-value">{{ detailData.payChannel || '建设银行' }}</span>
              </div>
              <div class="detail-item">
                <label class="detail-label">商户代码：</label>
                <span class="detail-value">{{ detailData.merchantId }}</span>
              </div>
              <div class="detail-item">
                <label class="detail-label">商户柜台代码：</label>
                <span class="detail-value">{{ detailData.posId }}</span>
              </div>
              <div class="detail-item">
                <label class="detail-label">分行代码：</label>
                <span class="detail-value">{{ detailData.branchId }}</span>
              </div>
            </div>
          </el-col>
          
          <el-col :span="12">
            <div class="detail-section">
              <h4 class="section-title">
                <i class="el-icon-setting"></i>
                配置信息
              </h4>
              <div class="detail-item">
                <label class="detail-label">启用状态：</label>
                <span :class="['detail-value', 'status-badge', detailData.openFlag === '1' ? 'status-enabled' : 'status-disabled']">
                  <i :class="detailData.openFlag === '1' ? 'el-icon-success' : 'el-icon-close'"></i>
                  {{ detailData.openFlag === "1" ? "启用" : "停用" }}
                </span>
              </div>
              <div class="detail-item">
                <label class="detail-label">添加时间：</label>
                <span class="detail-value time-value">{{ detailData.crtTime }}</span>
              </div>
              <div class="detail-item">
                <label class="detail-label">更新时间：</label>
                <span class="detail-value time-value">{{ detailData.updTime }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
        
        <div class="detail-section full-width">
          <h4 class="section-title">
            <i class="el-icon-key"></i>
            密钥信息
          </h4>
          <div class="detail-item">
            <label class="detail-label">公钥：</label>
            <div class="detail-value pub-key-container">
              <span class="pub-key-text">{{ detailData.pub }}</span>
              <el-button 
                type="text" 
                size="mini" 
                class="copy-btn"
                @click="copyPubKey"
                v-if="detailData.pub"
              >
                <i class="el-icon-document-copy"></i>
                复制
              </el-button>
            </div>
          </div>
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false" type="primary">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 验证码弹窗 -->
    <el-dialog
      title="请输入验证码"
      :visible.sync="captchaDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="captcha-content">
        <div class="captcha-phone-info">
          <i class="el-icon-mobile-phone"></i>
          <span>验证码已发送至手机 <strong>{{ maskedUserPhone }}</strong></span>
        </div>
        <div class="captcha-input-group">
          <div class="captcha-input-wrapper">
            <div class="captcha-input-title">
              <i class="el-icon-lock"></i>
              <span>验证码</span>
            </div>
                          <div class="captcha-input-container">
                <input
                  v-for="(digit, index) in 4"
                  :key="index"
                  v-model="captchaDigits[index]"
                type="text"
                maxlength="1"
                class="captcha-digit-input"
                :class="{ 'active': captchaDigits[index] }"
                @input="handleDigitInput(index, $event)"
                @keydown="handleDigitKeydown(index, $event)"
                @focus="handleDigitFocus(index)"
                ref="captchaInputs"
              />
            </div>
                          <div class="captcha-input-hint">
                <span>{{ captchaCode.length }}/4</span>
              </div>
          </div>
        </div>
        <div class="captcha-tip">
          <i class="el-icon-info"></i>
          <span>请输入4位数字验证码</span>
        </div>
        <div class="captcha-resend">
          <span class="resend-text">没收到验证码？</span>
          <el-button 
            type="text" 
            size="mini" 
            class="resend-btn"
            @click="resendCaptcha"
            :disabled="resendCountdown > 0"
          >
            {{ resendCountdown > 0 ? `${resendCountdown}s后重发` : '重新发送' }}
          </el-button>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelCaptcha">取 消</el-button>
        <el-button type="primary" @click="confirmCaptcha" :loading="captchaLoading">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import Page from "@/page/commons/page";
import ShareParkingTree from "@/page/commons/parking/commons/share-parking-tree.vue";
import { sharePaymentConfig,sharePaymentConfigList,getCaptcha } from "@/api/url";
export default {
  data() {
    return {
      paymentChannels: [
        {
          label: "建设银行",
          value: "CONSTRUCTION_BANK",
        },
        // {
        //   label: "工商银行",
        //   value: "INDUSTRIAL_BANK",
        // },
        // {
        //   label: "农业银行",
        //   value: "AGRICULTURAL_BANK",
        // },
        // {
        //   label: "中国银行",
        //   value: "BANK_OF_CHINA",
        // },
      ],
      dialogFormVisible: false,
      formData: {
        id: null,
        payChannel: "CONSTRUCTION_BANK",
        merchantId: null,
        posId: null,
        branchId: null,
        pub: null,
        openFlag: "y",
      },
      formLabelWidth: "120px",
      selectedParkingId: null,
      search: {
        // pageNumber: 1,
        // pageSize: 10,
        // payChannel: "",
        openFlag: "",
        parkingId: "",
      },
      tableListData: [],
      rules: {
        payChannel: [
          { required: true, message: "请选择支付渠道", trigger: "change" },
        ],
        merchantId: [
          { required: true, message: "请输入商户代码", trigger: "blur" },
        ],
        posId: [
          { required: true, message: "请输入商户柜台代码", trigger: "blur" },
        ],
        branchId: [
          { required: true, message: "请输入分行代码", trigger: "blur" },
        ],
        pub: [{ required: true, message: "请输入公钥", trigger: "blur" }],
        openFlag: [
          { required: true, message: "请选择启用状态", trigger: "change" },
        ],
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      detailDialogVisible: false,
      detailData: {},
      captchaDialogVisible: false,
      captchaCode: "",
      captchaLoading: false,
      pendingAction: null,
      pendingActionData: null,
      userPhone: "15013675419",
      resendCountdown: 0,
              captchaDigits: ["", "", "", ""],
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    handleTreeClick: function (node) {
      // 如果节点类型为停车场
      if (node.type === "parking") {
        this.selectedParkingId = node.id;
        this.search.parkingId = node.id;
        // 获取数据
        this.searchList();
      } else {
        this.selectedParkingId = null;
        this.search.parkingId = undefined;
      }
    },
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.searchList();
    },
    addOrEdit: function (id) {
      if(!id) {
        if(this.tableListData.length>=1) {
          this.$message.warning("每个停车场仅允许添加一个支付配置");
          return;
        }
      }
      this.pendingAction = 'addOrEdit';
      this.pendingActionData = id;
      this.showCaptchaDialog();
    },
    addEditTrue: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.formData.id) {
            // 编辑
            const params={...this.formData,parkingId: this.search.parkingId}
            delete params.payChannel;
            // delete params.crtTime;
            // delete params.updTime;
            this.$putRequest(`${sharePaymentConfig()}/${this.formData.id}`, {
              ...params
            }).then((res) => {
              if (res.status === 200) {
                //编辑成功的逻辑
                this.$message.success("修改成功");
                this.dialogFormVisible = false;
                this.searchList();
              } else {
                //编辑失败的逻辑
                this.$message.error("修改失败");
              }
            });
          } else {
            // 添加
            const params = {
              ...this.formData,
              parkingId: this.search.parkingId,
            };
            delete params.payChannel;
            this.$postRequest(sharePaymentConfig(), { ...params }).then(
              (res) => {
                if (res?.status !== 200) {
                  this.$message.error("添加失败");
                  return;
                }
                this.$message.success("添加成功");
                this.dialogFormVisible = false;

                this.searchList();
              }
            );
          }
        }
      });
    },
    toggleStatus: function (row, currentStatus) {
      this.pendingAction = 'toggleStatus';
      this.pendingActionData = { ...row, openFlag: currentStatus === 'y' ? 'n' : 'y' };
      this.showCaptchaDialog();
    },
    searchList: function () {
      // 这里可以添加实际的搜索逻辑
      this.$get(`${sharePaymentConfigList()}`, {
        ...this.search,
      }).then((res) => {
        if (res?.status === 200&&res?.data) {
          this.tableListData =(res?.data??[]).map((item)=>{return {...item,payChannel:item?.payChannel??'建设银行'}})
          console.log(this.tableListData)
          return;
        }
        this.tableListData = [];
      });
    },
    openDialog: function () {},
    closeDialog: function () {
      this.$refs.form.resetFields();
    },
    viewDetail: function (row) {
      this.pendingAction = 'viewDetail';
      this.pendingActionData = row;
      this.showCaptchaDialog();
    },
    copyPubKey: function () {
      if (this.detailData.pub) {
        navigator.clipboard.writeText(this.detailData.pub).then(() => {
          this.$message.success('公钥已复制到剪贴板');
        }).catch(() => {
          this.$message.error('复制失败，请手动复制');
        });
      }
    },
    showCaptchaDialog: function () {
      this.captchaCode = "";
      this.captchaDigits = ["", "", "", ""];
      this.captchaDialogVisible = true;
      
      // 自动发送验证码
      this.sendCaptcha();
      
      // 聚焦到第一个输入框
      this.$nextTick(() => {
        if (this.$refs.captchaInputs && this.$refs.captchaInputs[0]) {
          this.$refs.captchaInputs[0].focus();
        }
      });
    },
    cancelCaptcha: function () {
      this.captchaDialogVisible = false;
      this.captchaCode = "";
      this.captchaDigits = ["", "", "", ""];
      this.pendingAction = null;
      this.pendingActionData = null;
    },
    confirmCaptcha: function () {
      if (!this.captchaCode || this.captchaCode.length !== 4) {
        this.$message.error("请输入4位验证码");
        return;
      }
      
      this.captchaLoading = true;
      
      // 这里可以调用验证码验证接口
      // 模拟验证码验证
      setTimeout(() => {
        this.captchaLoading = false;
        
        // 验证码验证成功，执行相应的操作
        if (this.pendingAction === 'addOrEdit') {
          this.executeAddOrEdit(this.pendingActionData);
        } else if (this.pendingAction === 'viewDetail') {
          this.executeViewDetail(this.pendingActionData);
        } else if (this.pendingAction === 'toggleStatus') {
          this.executeToggleStatus(this.pendingActionData);
        }
        
        // 关闭验证码弹窗
        this.captchaDialogVisible = false;
        this.captchaCode = "";
        this.pendingAction = null;
        this.pendingActionData = null;
      }, 1000);
    },
    executeAddOrEdit: function (id) {
      this.dialogFormVisible = true;
      if (id) {
        // 编辑模式
        const row = this.tableListData.find((item) => item.id === id);
        if (row) {
          this.formData = { ...row };
        }
      } else {
        // 添加模式
        this.formData = {
          payChannel: "CONSTRUCTION_BANK",
          merchantId: null,
          posId: null,
          branchId: null,
          pub: null,
          openFlag: "1",
        };
      }
    },
    executeViewDetail: function (row) {
      this.detailData = { ...row };
      this.detailDialogVisible = true;
    },
    executeToggleStatus: function (data) {
            const params={...data,parkingId: this.search.parkingId}
            delete params.payChannel;
            // delete params.crtTime;
            // delete params.updTime;
            this.$putRequest(`${sharePaymentConfig()}/${data.id}`, {
              ...params
            }).then((res) => {
              if (res.status === 200) {
                //编辑成功的逻辑
                this.$message.success("修改成功");
                this.dialogFormVisible = false;
                this.searchList();
              } else {
                //编辑失败的逻辑
                this.$message.error("修改失败");
              }
            });
     
    },
    sendCaptcha: function () {
      // 这里可以调用发送验证码接口
      this.$postRequest(`${getCaptcha()}`,{type:1,mobile:this.userPhone}).then((res)=>{
        if(res?.status!==200) {
          this.$message.error(res?.message||'发送验证码失败，请稍后重试');
          return;
        }
        this.$message.success('验证码已发送至手机');
      })
      
      
      // 开始倒计时
      this.resendCountdown = 60;
      const timer = setInterval(() => {
        this.resendCountdown--;
        if (this.resendCountdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    resendCaptcha: function () {
      if (this.resendCountdown > 0) return;
      
      // 这里可以调用重发验证码接口
      this.$message.success('验证码已重新发送');
      
      // 开始倒计时
      this.resendCountdown = 60;
      const timer = setInterval(() => {
        this.resendCountdown--;
        if (this.resendCountdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    handleDigitInput: function (index, event) {
      const value = event.target.value;
      
      // 只允许数字
      if (!/^\d$/.test(value)) {
        this.captchaDigits[index] = "";
        return;
      }
      
      this.captchaDigits[index] = value;
      
              // 自动跳转到下一个输入框
        if (value && index < 3) {
          this.$nextTick(() => {
            this.$refs.captchaInputs[index + 1].focus();
          });
        }
      
      // 更新验证码字符串
      this.updateCaptchaCode();
    },
    handleDigitKeydown: function (index, event) {
      // 处理退格键
      if (event.key === 'Backspace' && !this.captchaDigits[index] && index > 0) {
        this.$nextTick(() => {
          this.$refs.captchaInputs[index - 1].focus();
        });
      }
      
      // 处理回车键
      if (event.key === 'Enter') {
        this.confirmCaptcha();
      }
    },
    handleDigitFocus: function (index) {
      // 聚焦时选中内容
      this.$nextTick(() => {
        this.$refs.captchaInputs[index].select();
      });
    },
    updateCaptchaCode: function () {
      this.captchaCode = this.captchaDigits.join('');
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      parking: (state) => state.parking.oneParking,
    }),
    ...mapGetters(["elements"]),
    maskedUserPhone() {
      if (!this.userPhone || this.userPhone.length < 7) {
        return this.userPhone;
      }
      // 保留前3位和后4位，中间用****替换
      const start = this.userPhone.substring(0, 3);
      const end = this.userPhone.substring(this.userPhone.length - 4);
      return `${start}****${end}`;
    },
  },
  components: {
    Page,
    ShareParkingTree,
  },
  mounted: function () {},
};
</script>

<style scoped>
.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.el-input {
  display: inline-block;
  width: 200px;
}

.btns {
  margin: 20px auto 0;
  width: 150px;
}
.searchbox {
  padding-bottom: 10px;
}
.clearth {
  clear: both;
}
.area {
  width: 100%;
  display: inline-block;
}
.view,
.edit,
.reset {
  display: inline-block;
  width: 40px;
  height: 20px;
  background: #278cd8;
  color: white;
  margin-right: 4px;
  font-size: 12px;
  line-height: 20px;
  border-radius: 4px;
}
.view{
  background:none !important;
  color:#409EFF !important;
}

/* 详情弹窗美化样式 */
.detail-dialog .el-dialog__body {
  padding: 0;
}

.detail-header {
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  color: rgb(21, 20, 20);
  padding: 20px;
  border-radius: 8px 8px 0 0;
  margin: -20px -20px 20px -20px;
}

.detail-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
}

.detail-title i {
  margin-right: 10px;
  font-size: 24px;
}

.detail-content {
  padding: 0 20px 20px 20px;
}

.detail-section {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #e9ecef;
}

.detail-section.full-width {
  margin-top: 20px;
}

.section-title {
  margin: 0 0 15px 0;
  color: #495057;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  border-bottom: 2px solid #dee2e6;
  padding-bottom: 8px;
}

.section-title i {
  margin-right: 8px;
  color: #6c757d;
}

.detail-item {
  display: flex;
  margin-bottom: 12px;
  align-items: flex-start;
}

.detail-item:last-child {
  margin-bottom: 0;
}

.detail-label {
  min-width: 120px;
  color: #6c757d;
  font-weight: 500;
  margin-right: 10px;
  line-height: 1.5;
}

.detail-value {
  color: #212529;
  font-weight: 500;
  line-height: 1.5;
  flex: 1;
}

.channel-value {
  color: #007bff;
  font-weight: 600;
}

.time-value {
  color: #6c757d;
  font-size: 14px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
}

.status-badge i {
  margin-right: 5px;
}

.pub-key-container {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 12px;
}

.pub-key-text {
  flex: 1;
  word-break: break-all;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  line-height: 1.4;
  color: #495057;
  margin-right: 10px;
}

.copy-btn {
  flex-shrink: 0;
  color: #007bff;
  padding: 4px 8px;
}

.copy-btn:hover {
  color: #0056b3;
  background: #e3f2fd;
  border-radius: 4px;
}

.detail-dialog .el-dialog__footer {
  padding: 15px 20px;
  border-top: 1px solid #e9ecef;
  background: #f8f9fa;
}

/* 验证码弹窗样式 */
.captcha-content {
  text-align: center;
  padding: 20px 0;
}

.captcha-input-group {
  margin-bottom: 20px;
}

.captcha-input-wrapper {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.captcha-input-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  color: #606266;
  font-size: 16px;
  font-weight: 500;
}

.captcha-input-title i {
  margin-right: 8px;
  color: #409EFF;
  font-size: 18px;
}

.captcha-input-container {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 15px;
}

.captcha-digit-input {
  width: 50px;
  height: 50px;
  border: 2px solid #dcdfe6;
  border-radius: 8px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  background: #fff;
  transition: all 0.3s ease;
  outline: none;
}

.captcha-digit-input:focus {
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  transform: translateY(-2px);
}

.captcha-digit-input.active {
  border-color: #67c23a;
  background: #f0f9ff;
}

.captcha-digit-input:hover {
  border-color: #c0c4cc;
}

.captcha-input-hint {
  text-align: center;
  color: #909399;
  font-size: 14px;
  font-weight: 500;
}

.captcha-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}

.captcha-tip i {
  margin-right: 5px;
  color: #409EFF;
}

.captcha-phone-info {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f9ff;
  border: 1px solid #b3d8ff;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 20px;
  color: #1890ff;
  font-size: 14px;
}

.captcha-phone-info i {
  margin-right: 8px;
  font-size: 16px;
  color: #1890ff;
}

.captcha-phone-info strong {
  color: #1890ff;
  font-weight: 600;
}

.captcha-resend {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #f0f0f0;
}

.resend-text {
  color: #909399;
  font-size: 14px;
  margin-right: 8px;
}

.resend-btn {
  color: #409EFF;
  font-size: 14px;
  padding: 0;
}

.resend-btn:hover:not(:disabled) {
  color: #66b1ff;
}

.resend-btn:disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}
.list {
  position: relative;
}
.pagbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
.el-radio {
  display: inline-block;
  height: 34px;
  line-height: 34px;
}
.el-form-item__error,
.el-input {
  float: left;
}
.tip {
  margin-top: -2%;
  color: red;
  font-size: 14px;
  font-weight: bold;
}
hr {
  margin: 5px 0 10px 0 !important;
  border-top: 1px solid #ddd !important;
}
.table > tbody > tr > td {
  border: none;
}
.download_btn .el-dropdown-link {
  display: inline-block;
  cursor: pointer;
  color: white;
  background: #278cd8;
  height: 34px;
  border-radius: 5px;
  padding-left: 5px;
  font-size: 12px;
  line-height: 37px;
  width: 90px;
}
.download_btn .el-icon-arrow-down {
  font-size: 12px;
}
.status-enabled {
  color: #67c23a;
  font-weight: bold;
}
.status-disabled {
  color: #f56c6c;
  font-weight: bold;
}
.no-parking-tip {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  color: #909399;
}
.tip-content {
  text-align: center;
}
.tip-content i {
  font-size: 48px;
  margin-bottom: 20px;
  color: #e6a23c;
}
.tip-content p {
  font-size: 16px;
  margin: 0;
}
</style>
<style>
.chargeSearchbox .form-control {
  width: 100px !important;
}
.charge .el-dropdown-menu {
  width: 200px !important;
}
/* 增加input框高度 */
.form-edit .el-input__inner {
  height: 35px !important;
  line-height: 35px !important;
  border-radius: 4px !important;
}
/* 增加textarea高度 */
.form-edit .el-textarea__inner {
  min-height: 80px !important;
}
/* 搜索栏按钮样式 */
.searchbox .btn-primary {
  background-color: #409EFF !important;
  border-color: #409EFF !important;
}
.searchbox .btn-primary:hover {
  background-color: #66b1ff !important;
  border-color: #66b1ff !important;
}
.searchbox .btn-primary:active {
  background-color: #3a8ee6 !important;
  border-color: #3a8ee6 !important;
}
/* 使用更具体的选择器提高优先级 */
.searchbox .chargeSearchbox .btn-primary,
.searchbox.chargeSearchbox .btn-primary {
  background-color: #409EFF !important;
  border-color: #409EFF !important;
}
.searchbox .chargeSearchbox .btn-primary:hover,
.searchbox.chargeSearchbox .btn-primary:hover {
  background-color: #66b1ff !important;
  border-color: #66b1ff !important;
}
.searchbox .chargeSearchbox .btn-primary:active,
.searchbox.chargeSearchbox .btn-primary:active {
  background-color: #3a8ee6 !important;
  border-color: #3a8ee6 !important;
}
/* 禁用状态的添加按钮样式 */
.btn-disabled {
  background-color: #f5f7fa !important;
  border-color: #e4e7ed !important;
  color: #c0c4cc !important;
}
.btn-disabled:hover {
  background-color: #f5f7fa !important;
  border-color: #e4e7ed !important;
  color: #c0c4cc !important;
}
</style>